import React, {ReactNode, useEffect} from 'react';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import TimeToStartTimer from 'app/utils/TimeToStartTimer';
import {inject, observer} from 'mobx-react';
import {CurrentTimeStore} from 'stores/current_time_store';
import {SEC_IN_DAY} from 'app/utils/Consts';
import I18n from 'app/i18n';

interface BonusesCardTimeProps {
    timeLeft: number;
    hideExpiredBonus: () => void;
    currentTimeStore?: CurrentTimeStore;
}

const BonusesCardTime = (props: BonusesCardTimeProps): ReactNode => {
    const {timeLeft, currentTimeStore, hideExpiredBonus: hideExpiredBonusProps} = props;
    const {t} = currentTimeStore;
    const showDays = timeLeft - t >= SEC_IN_DAY;
    const hideExpiredBonus = timeLeft > 0 && timeLeft - t < 0;

    useEffect(() => {
        if (hideExpiredBonus) {
            hideExpiredBonusProps();
        }
    }, [hideExpiredBonus, hideExpiredBonusProps]);

    return <div className="bonuses-card-time">
        <SpriteIcon name="#svg-timer-icon" size={{height: 14, width: 14}}/>
        {timeLeft > 0
            ? <span className="bonuses-card-time__text">
                <TimeToStartTimer time_to_start={timeLeft} showOnlyDays={showDays}/>
            </span>
            : <span className="bonuses-card-time__text bonuses-card-time__text--permanent">{I18n.t('bonuses_page.permanent')}</span>}
    </div>;
};

export default inject('currentTimeStore')(observer(BonusesCardTime));
